import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6fc8f744&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6fc8f744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8f744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc8f744')) {
      api.createRecord('6fc8f744', component.options)
    } else {
      api.reload('6fc8f744', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6fc8f744&scoped=true&", function () {
      api.rerender('6fc8f744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/driverInfo/index.vue"
export default component.exports